import Spacing from 'components/Common/Spacing'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import LFSEOfferTypeTiles from './LFSEOfferTypeTiles'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { LFSEOfferType, LOOKING_FOR_SOMETHING_ELSE_CONTENT } from 'home/components/LookingForSomethingElse/constants'
import TextButton from 'components/Luxkit/Button/TextButton'
import * as Analytics from 'analytics/analytics'
import { clickViewAllCarouselExclusive } from 'analytics/snowplow/events'
import { themeClassName } from 'lib/theme/themeUtils'
const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
  height: 100%;
  width: ${rem(388)};

  ${mediaQueryUp.tablet} {
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  }
`

interface Props {
  offerType?: LFSEOfferType;
  link?: string;
}

function HeroOfferCarouselLookingForSomethingElse({ offerType, link }: Props) {
  const { to, label } = offerType ? LOOKING_FOR_SOMETHING_ELSE_CONTENT[offerType] : { to: undefined, label: undefined }

  const onClickViewAll = useCallback(() => {
    if (offerType) {
      Analytics.track('view-all-carousel-homepage', clickViewAllCarouselExclusive(offerType))
    }
  }, [offerType])

  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center" className={themeClassName('inverse')}>
      <Heading align="center" variant="heading5">Looking for something else?</Heading>
      <Spacing mt={8} mb={24}>
        <BodyText colour="neutral-two" align="center" variant="medium">Browse all destinations or {label ?? 'products'} for more amazing offers</BodyText>
      </Spacing>
      {!offerType && <Group direction="vertical" gap={8} className={themeClassName('default')}>
        <LFSEOfferTypeTiles />
      </Group>}
      {offerType && <TextButton kind="primary" size="medium" shape="square" to={link ?? to} onClick={onClickViewAll}>
        View all
      </TextButton>}
    </Container>
  )
}

export default HeroOfferCarouselLookingForSomethingElse
